import React from "react";
import { Link } from "react-router-dom";
import { AiFillYoutube } from "react-icons/ai";
import { GrInstagram } from "react-icons/gr";
import { FaLinkedin } from "react-icons/fa";
import { FaGit } from "react-icons/fa";

const Footer = () => {
  return (
    <div className=" py-10 sm:py-20 shadow-2xl flex items-center justify-around px-10 bg-gradient-to-r from-[#000000] to-[#151414b0]">
      
      <div className="flex flex-col items-center">
        <p className="font-normal text-sm pb-5">
          {/* Check out my social media platforms */}
        </p>
        <div className="flex sm:gap-4 md:gap-5 gap-2 ">
          <Link
            to={"https://www.youtube.com/@chinjuansa"}
            target="_blank"
            rel="noopener noreferrer"
            className="hover:scale-110 transition-transform duration-200"
          >
            <AiFillYoutube size={35} color="red" />
          </Link>
          <Link
            to={
              "https://www.instagram.com/chinjus_dream_weaving?igsh=MW4wemF0ZG16Mm5xdQ%3D%3D&utm_source=qr"
            }
            target="_blank"
            rel="noopener noreferrer"
            className="hover:scale-110 transition-transform duration-200"
          >
            <GrInstagram size={30} color="#E4405F" />
          </Link>
          <Link
            to={"https://www.linkedin.com/in/ansa-ali-anas/"}
            target="_blank"
            rel="noopener noreferrer"
            className="hover:scale-110 transition-transform duration-200"
          >
            <FaLinkedin size={30} color="#0077B5" />
          </Link>
          <Link
            to={"https://www.linkedin.com/in/ansa-ali-anas/"}
            target="_blank"
            rel="noopener noreferrer"
            className="hover:scale-110 transition-transform duration-200"
          >
            <FaGit size={35} color="#f34f29" />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Footer;
